export const payeeVerificationIDTypes = [
  { value: '01', label: '01 - New IC' },
  { value: '02', label: '02 - Old IC' },
  { value: '03', label: '03 - Passport No' },
  { value: '04', label: '04 - Army / Police' },
  { value: '05', label: '05 - Business Registration Number' },
]

export const residentStatusOptions = [
  { value: 'Y', label: 'Y' },
  { value: 'N', label: 'N' },
]

export const bankCodeOptions = [
  { value: 'MBBEMYKL', label: 'MBBEMYKL - Maybank' },
  { value: 'CIBBMYKL', label: 'CIBBMYKL - CIMB Bank' },
  { value: 'PABOREMYKL', label: 'PABOREMYKL - Public Bank' },
  { value: 'RHBBMYKL', label: 'RHBBMYKL - RHB Bank' },
  { value: 'HLBBMYKL', label: 'HLBBMYKL - Hong Leong Bank' },
  { value: 'AMMBMYKL', label: 'AMMBMYKL - AmBank' },
]

export const beneBankSetupOptions = [
  {
    value: 'RHB',
    label: 'Affin Bank Berhad',
    beneficiaryBankCode: 'PHBMMYKL',
    ibgBankCode: 'PHBMMYKL',
    ownBank: 'N',
  },
  {
    value: 'ORHB',
    label: 'RHB Bank Berhad',
    beneficiaryBankCode: 'RHBBMYKL',
    ibgBankCode: 'RHBBMYKL',
    ownBank: 'N',
  },
  {
    value: 'MBB',
    label: 'Malayan Banking Berhad',
    beneficiaryBankCode: 'MBBEMYKL',
    ibgBankCode: 'MBBEMYKL',
    ownBank: 'Y',
  },
  {
    value: 'IMBB',
    label: 'Affin Bank Berhad',
    beneficiaryBankCode: 'PHBMMYKL',
    ibgBankCode: 'PHBMMYKL',
    ownBank: 'N',
  },
]

export const paymentPurposeOptions = [
  { value: 'SALA', label: 'SALA - Salary Payment' },
  { value: 'SUPP', label: 'SUPP - Supplier Payment' },
  { value: 'TAXS', label: 'TAXS - Tax Payment' },
  { value: 'TRAD', label: 'TRAD - Trade Settlement Payment' },
  { value: 'DIVD', label: 'DIVD - Dividend Payment' },
]
